import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { GlobalMessage } from '../../utility/modals';
import { ClientusagereportService } from './clientusagereport.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
@Component({
  selector: 'app-clientusagereport',
  templateUrl: './clientusagereport.component.html',
  styleUrls: ['./clientusagereport.component.css'],
  providers: [DatePipe]
})
export class ClientusagereportComponent {
  ref: DynamicDialogRef | undefined;
  orgs: any[] = [];
  items: MenuItem[] | undefined;
  datalist: Array<any> = [];
  selectedOrgs: any[] = [];
  date1: null;
  selectedorgid: any;
  orgid: number | null = null;
  fromDate: Date | null = null;
  toDate: Date | null = null;
  errorDIsplay = false;
  excel_paragraph = '';
  message: GlobalMessage = new GlobalMessage();
  templatedownloadtext = '';

  constructor(
    private clientService: ClientusagereportService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    //private dashbordservice:DashboardService,
    public helpservice: PagehelpmodalService,
    public dialogService: DialogService) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text


  }

  ngOnInit(): void { 
    this.getOrganisations();
  }

  getOrganisations() {
    this.clientService.getorganisations().subscribe(result => {
      this.orgs = result;
    });
  }


  exceDownloadModel() { }

  tempuse: any;
  getcompanydata() {
    if (!this.selectedorgid) { Swal.fire({ title: 'Please choose an organisation.', icon: 'warning' }); return; }
    if (!this.fromDate) { Swal.fire({ title: 'Please select From Date.', icon: 'warning' }); return; }
    if (!this.toDate) { Swal.fire({ title: 'Please select To Date.', icon: 'warning' }); return; }
    if (this.fromDate > this.toDate) {
      this.errorDIsplay = true;
      return;
    } else {
      this.errorDIsplay = false;
    }

    const payload = {
      orgid: this.selectedorgid,
      fromdate: this.fromDate ? this.formatDate(this.fromDate) : null,
      todate: this.toDate ? this.formatDate(this.toDate) : null
    };

    this.spinner.show();
    this.clientService.getcompanystats(payload).subscribe((data) => {
      this.datalist = data;
      this.spinner.hide();
    }
      , error => {
        this.spinner.hide();
        Swal.fire({ icon: "error", title: "Oops...", text: error.error.error, footer: "error status is :" + ' ' + error.status });
      });
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  validateDates() {
    if (this.fromDate && this.toDate && this.fromDate > this.toDate) {
      this.errorDIsplay = true;
    } else {
      this.errorDIsplay = false;
    }
  }
  orgidchange(event: any) {
    this.datalist = null;
    this.selectedorgid = event?.value;
  }

  refreshData() {
    this.selectedorgid = null;
    this.fromDate = null;
    this.toDate = null;
    this.datalist = null;

  }

  //Download  Excel
  generateExcel() {
    if (!this.selectedorgid) { Swal.fire({ title: 'Please choose an organisation.', icon: 'warning' }); return; }
    if (!this.fromDate) { Swal.fire({ title: 'Please select From Date.', icon: 'warning' }); return; }
    if (!this.toDate) { Swal.fire({ title: 'Please select To Date.', icon: 'warning' }); return; }
    if (this.fromDate > this.toDate) { this.errorDIsplay = true; return; }
    else { this.errorDIsplay = false; }
    const payload = {
      fromdate: this.datePipe.transform(this.fromDate, 'yyyy-MM-dd'),
      todate: this.datePipe.transform(this.toDate, 'yyyy-MM-dd'),
      orgid: this.selectedorgid
    };
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: '44vw',
      height: '10vw',
      data: {
        excelname: "Clientusage.xlsx", downloadapi: 'common/clientusagereport/exceldatadownload',
        method: 'post', message: this.excel_paragraph, payload: payload
      },
      contentStyle: { overflow: 'hidden' },
      position: 'center'

    })
  }

     //Download  Excel
   generateallExcel() {
    if (!this.fromDate) {Swal.fire({title: 'Please select From Date.',icon: 'warning'});return;}
    if (!this.toDate) {Swal.fire({title: 'Please select To Date.',icon: 'warning'  }); return;}
    if (this.fromDate > this.toDate) {this.errorDIsplay = true;return; }
    else {this.errorDIsplay = false;}
    const payload = {
      fromdate: this.datePipe.transform(this.fromDate, 'yyyy-MM-dd'),
      todate: this.datePipe.transform(this.toDate, 'yyyy-MM-dd'),
    };
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: '44vw',
      height: '10vw',
      data: {
        excelname: "Clientusage.xlsx", downloadapi: 'common/clientusagereport/exceldatadownloadall',
        method: 'post', message: this.excel_paragraph, payload: payload
      },
      contentStyle: { overflow: 'hidden' },
      position: 'center'
 
    })
  }
   
 
 


  onClear() {
    this.fromDate = undefined!;
    this.toDate = undefined!;
    this.selectedOrgs = [];
  }
  getOrgTooltip(): string {
    if (!this.selectedOrgs || this.selectedOrgs.length === 0) {
      return 'Select Organisation';
    }

    const selectedLabels = this.orgs
      .filter(option => this.selectedOrgs.includes(option.orgid))
      .map(option => option.name);

    return selectedLabels.join(', ');
  }

}
